import * as React from 'react';

import { IGlob } from '../ts/Glob';
import { IErrorMessage } from '../ts/Interfaces';

interface IErrorFormProps {
    glob: IGlob;
    error: IErrorMessage;
}

export const ErrorForm: React.FC<IErrorFormProps> = (props) => {
    const getContent = () => {
        let buttonStyle: React.CSSProperties = {};
        let titleStyle: React.CSSProperties = {};
        let textStyle: React.CSSProperties = {};

        if (props.glob.customErrorForm != null) {
            const styles = props.glob.customErrorForm.getErrorFormElementStyles();
            buttonStyle = styles.buttonStyle;
            titleStyle = styles.titleStyle;
            textStyle = styles.textStyle;
        }

        let headerClass = 'btn-default';
        switch (props.error.severity) {
            case 'high':
                headerClass = 'btn-danger';
                break;
            case 'medium':
                headerClass = 'btn-default';
                break;
            case 'low':
                headerClass = 'btn-info';
                break;
        }

        if (props.error != null) {
            return (
                <div>
                    <div className={'modal-header ' + headerClass}>
                        <h4 className="modal-title" style={titleStyle}>
                            {props.error.title}
                        </h4>
                    </div>
                    <div className="modal-body" style={textStyle}>
                        {Array.isArray(props.error.message)
                            ? props.error.message.map((m) => <p>{m}</p>)
                            : props.error.message}
                    </div>
                    <div className="modal-footer">
                        <button
                            className="btn btn-primary"
                            style={buttonStyle}
                            onClick={() => props.glob.mainRouter.navigate('/', { trigger: true, replace: true })}
                        >
                            Home
                        </button>
                    </div>
                </div>
            );
        }
    };
    //return (
    return props.glob.customErrorForm != null ? (
        props.glob.customErrorForm.getErrorFormContent(getContent())
    ) : (
        <div className="popup-sign-in">{getContent()}</div>
    );
};

